module.exports = __webpack_public_path__ + "img/compra-segura.f3d36bcd.svg";